import { DesktopDisplayContainer } from '@components/DeviceContainer'
import ImageWithFallback from '@components/ImageWithFallback'
import React from 'react'
import styled from 'styled-components'
import tw from 'twin.macro'
import useUserInfo from './useUserInfo'
import EditButton from './EditButton'
import { FollowButton, FollowingButton } from './FollowButtons'

const DesktopUserInfoContainer = styled.div`
  position: relative;
  max-width: 769px;
  margin: 0 auto;
  margin-top: 44px;
  display: flex;
  word-break: break-all;
`

const Avatar = styled(ImageWithFallback)`
  width: 88px;
  height: 88px;
  margin-right: 20px;
  border-radius: 44px;
`

const Title = styled.div`
  ${tw`text-h2 font-600`}
`

const IDContainer = styled.div`
  ${tw`text-h6 text-gray-400`}
  margin-top: 4px;
`

const Description = styled.div`
  ${tw`text-gray-600`}
  margin-top: 12px;
  a {
    ${tw`text-primary-indigo`}
  }
`

const ProfileDataContainer = styled.div`
  display: flex;
  margin-top: 12px;
`

interface ProfileDataItemContainerProps {
  index: number
}

const ProfileDataItemContainer = styled.a<ProfileDataItemContainerProps>`
  ${tw`text-gray-800`}
  display: flex;
  align-items: center;
  margin-left: ${(props) => (props.index === 0 ? '0px' : '20px')};
`

const ProfileDataCategory = styled.div`
  ${tw`text-h5 font-400`}
  margin-left: 4px;
`

const ProfileDataNumber = styled.div`
  ${tw`text-h4 font-600`}
`

const DesktopUserInfo = () => {
  const {
    mid,
    des,
    profileData,
    name,
    isMeRoute,
    photoUrl,
    isUserFollowing,
    handleFollowButtonOnClick,
    handleFollowingButtonOnClick,
    isSelf,
    handleEditButtonOnClick,
  } = useUserInfo()

  return (
    <DesktopDisplayContainer>
      <DesktopUserInfoContainer>
        <Avatar src={photoUrl} />
        <div>
          <Title>{name}</Title>
          <IDContainer>ID {mid}</IDContainer>
          <Description dangerouslySetInnerHTML={{ __html: des }} />
          <ProfileDataContainer>
            {profileData.map((data, index) => {
              return (
                <ProfileDataItemContainer
                  index={index}
                  key={data.name}
                  href={data.href}
                  onClick={data.onClick}
                >
                  <ProfileDataNumber>{data.number}</ProfileDataNumber>
                  <ProfileDataCategory>{data.name}</ProfileDataCategory>
                </ProfileDataItemContainer>
              )
            })}
          </ProfileDataContainer>
        </div>
        {
          <div tw="ml-auto mt-3">
            {isMeRoute && <EditButton handleOnClick={handleEditButtonOnClick} />}
            {!isMeRoute && isSelf && <EditButton handleOnClick={handleEditButtonOnClick} />}
            {!isMeRoute &&
              !isSelf &&
              (isUserFollowing ? (
                <FollowingButton onClick={handleFollowingButtonOnClick} />
              ) : (
                <FollowButton onClick={handleFollowButtonOnClick} />
              ))}
          </div>
        }
      </DesktopUserInfoContainer>
    </DesktopDisplayContainer>
  )
}

export default DesktopUserInfo
